import type { GetStaticProps, NextPage } from "next"
import { ReactElement } from "react"
import { brand, brands } from "~/brand"
import { Home } from "~/marketing/canyouunlock.com/Home"

const brandIndexPages: Record<keyof typeof brands, () => ReactElement> = {
  "canyouunlock.com": Home,
}

export const getStaticProps: GetStaticProps = async () => ({ props: {} })

const IndexPage: NextPage = () => {
  const Page = brandIndexPages[brand.id]

  if (!Page) return null // Shouldn't happen
  return <Page />
}

export default IndexPage
